import styled, { createGlobalStyle } from "styled-components";

export function Layout({ children }) {
  return (
    <Page className="Page">
      <StyleOverride />
      <MaxWidthWrapper className="MaxWidthWrapper">{children}</MaxWidthWrapper>
    </Page>
  );
}

const StyleOverride = createGlobalStyle`
  .background-image {
  --body-background: var(--body-color);
}
`;

const Page = styled.div({
  backgroundColor: "var(--body-color)",
  padding: "20px 40px",
  color: "rgb(66, 53, 33)",
  "@media(min-width: 800)": {
    padding: "40px 100px",
  },
  "@media (max-width: 480px)": {
    padding: "20px",
  },
});

const MaxWidthWrapper = styled.div({
  maxWidth: "1000px",
  margin: "0 auto",
});
